<div class="buttons is-right is-hidden-print" *ngIf="currentStep >= 0">
    <button class="button is-secondary" *ngIf="currentStep !== 0 " (click)="prev.emit()">Previous</button>
    <button class="button is-primary" *ngIf="currentStep + 1 < steps" (click)="next.emit()">Next</button>
</div>
